import '../custom_facets/custom_facets_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyNPSFilterView extends Monitoring.Views.SocialContents.Filters.CustomFacetsFilterView
  isEmpty: ->
    nps_applied_filters = @searchQuery.get('custom_facets')['custom_nps']
    nps_applied_filters?.length > 0
